import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userDataKader = localStorage.getItem("userDataKader") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader")))) : "";

var serviceName = "index";
var postaService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userDataKader["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userDataKader["firmaKodu"] + "/orta/",
    imageUrlKucuk: WsProvider.resim + "/" + userDataKader["firmaKodu"] + "/kucuk/",
    imageUrlEnKucuk: WsProvider.resim + "/" + userDataKader["firmaKodu"] + "/enkucuk/",
    path  : "https://www.kaderfood.ch/",
    postaKoduTanimlama(baslik) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                baslik: baslik,

                serviceName: "posta",
                methodName: "postaKoduTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    postaKoduDetay(postakoduId) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                postakoduId: postakoduId,
                serviceName: "posta",
                methodName: "postaKoduDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },


    postaKoduList(durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                durum: durum,
                serviceName: "posta",
                methodName: "postaKoduList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    postaKoduCount(durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                durum: durum,
                serviceName: "posta",
                methodName: "postaKoduCount"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    postaKoduDurumGuncelle(postakoduId, durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                postakoduId: postakoduId,
                durum: durum,
                serviceName: "posta",
                methodName: "postaKoduDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    postaKoduGuncelle(postakoduId, baslik) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                postakoduId: postakoduId,
                baslik: baslik,
                serviceName: "posta",
                methodName: "postaKoduGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    postaKoduMasaList(postakoduId) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                postakoduId: postakoduId,
                serviceName: "posta",
                methodName: "postaKoduMasaList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },


}

export default postaService

